import React from 'react'
import AppConnector from '../../AppConnector';
import GlobalStorage from '../storage/GlobalStorage'
import {Container,Row,Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,UncontrolledDropdown,DropdownToggle,DropdownMenu,DropdownItem ,Input, InputGroup} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faUpload} from '@fortawesome/free-solid-svg-icons'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
    this.connector = new AppConnector
    this.handleFileChange = this.handleFileChange.bind(this);
    this.triggerInputFile = this.triggerInputFile.bind(this);
    this.warningList = this.GS.getStory().warningList;
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggleCheckbox(label)
  {
    if (this.warningList.has(label)) {
      this.warningList.delete(label);
    } else {
      this.warningList.add(label);
    }
  
  }

  handleFileChange(event) {
    var url = URL.createObjectURL(event.target.files[0]);
    this.setState({
      file: url
    });
    this.GS.getStory().image.large = url;
    //console.log(this.GS.getStory().image.large);
    this.forceUpdate();
  }

  triggerInputFile = () => this.fileInput.click();

  
  render()
  { console.log(this.warningList); console.log(this.warningList.has('SIXTEEN_PLUS'));
    
    return (
        <div>
          <Navbar color="dark" dark expand="md">
            <Container>
              <NavbarBrand href="https://tbcstory.com/">tbc... {(global.DEBUG)?'(Story)':''}</NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                {this.GS.getUser().token!==null?(
                  <NavItem>
                    <NavLink href="#" className="active" onClick={()=>{
                        this.props.switchMain('StoryList');
                        this.props.switchMenu("StoryList");                    
                      }}>我的故事</NavLink>
                  </NavItem>
                ):null}
                  <NavItem>
                    <NavLink href="#" onClick={()=>{
                      this.props.switchMain('FAQ');
                      this.props.switchMenu("FAQ");                    
                    }}>常見問題</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="#" onClick={()=>{
                      this.props.switchMain('Home');
                      this.props.switchMenu("Home");                    
                    }}>教學</NavLink>
                  </NavItem>
                  {this.GS.getUser().token!==null?(
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                    Hello, {(this.GS.getUser().reader)?this.GS.getUser().reader.displayName:""} 
                      <FontAwesomeIcon className="ml-1" icon={faUser}/>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem onClick={()=>{
                        this.props.toggleModalState('updateMemberProfile');
                        this.props.toggleModal(true);
                      }}>
                        設定
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={()=>{this.GS.logout();
                        this.props.switchMain('Home');
                        this.props.switchMenu("Home");                    
                      }}>
                        登出
                      </DropdownItem>                      
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  ):(
                    <NavItem>
                      <NavLink href="#" onClick={()=>{
                        this.props.toggleModalState('login');
                        this.props.toggleModal(true);
                      }}>登入</NavLink>
                    </NavItem>
                  )}
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
          <style dangerouslySetInnerHTML={{__html: `
            .covercontainer {
              
              width: 240px;
              margin:0 auto
          }
            .textcontainer {
              width: 400px;
              float: left;
              margin-left: 100px;
              color: #ffffff;
          }
            .storyName {
              margin: 50px 0 15px;
              font-size: 44px;
              font-weight: 400;
              letter-spacing: 8px;
              font-size: 1.5em;
          }
            hr {
              filter: alpha(opacity=20);
              -moz-opacity: 0.2;
              -khtml-opacity: 0.2;
              opacity: 0.2;
              display: block;
              width: 100px;
              height: 0;
              border: none;
              border-top: 1px solid #ffffff;
              margin: 20px 0;
          }
            .description {
              font-size: 14px;
              font-weight: 300;
              line-height: 140%;
              letter-spacing: 3px;
              margin: 0 0 20px;
              background:#000;
              color: #FFF;
              border: 0;
              width: 100%;
              min-height: 110px;
          }          
          .description:after{
            content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAiUlEQ…Epfs6CRRPJmqEGvAC6IAlId4NcQk58vwDih0DbMxhGDgAAx6ZVXMd4yEMAAAAASUVORK5CYII=);
            width: 8px;
            height: 8px;
            display: inline-block;
            content: '';
          }

          `}}>
          </style>
          <Container style={{maxWidth: `860px`}}>
            <Row>
              <section class="content" style={{display: `flex`,alignItems: `center`}}>
                  <div class="covercontainer">

                  <div class="hovereffect p-3 hoverBtn" onClick={()=>{
                      this.triggerInputFile();
                  }}>
                      {this.GS.getStory().image.hasOwnProperty('large')?(
                        <img src={this.GS.getStory().image.large} class="img-fluid"/>
                      ):(<img src="story.jpg"  class="img-fluid"/>)}                                                            
                      <div class="overlay">                  
                        <p class="icon-links">
                          <a href="javascript:void(0)">                                                  
                            <input type="file" accept="image/*" id="story-cover-image" name="cover-image" onChange={this.handleFileChange} className={`inputfile`} ref={fileInput => this.fileInput = fileInput} />
                            <label for="story-cover-image" class="">
                              <FontAwesomeIcon icon={faUpload} title="上傳封面" uuid={this.GS.getStory().uuid}/>
                            </label>          
                          </a>                    
                        </p>
                      </div>                
                    </div>                    
                  </div>

                  <div class="textcontainer">
                      <h1 class="storyName" contentEditable='true'
                        onInput=
                        {
                          e => this.GS.getStory().storyName = e.currentTarget.textContent
                        }
                      >
                        {this.GS.getStory().storyName}                        
                      </h1>
                      {(global.DEBUG)?this.GS.getStory().uuid:''}
                      <h3>
                          <span class="author" contentEditable='true'
                          onInput=
                          {
                            e => {
                            this.GS.getStory().author = e.currentTarget.textContent;
                            this.GS.getStoryEpisode().author = e.currentTarget.textContent;
                            }
                          }
                          >
                            {this.GS.getStory().author}
                          .</span>                          
                          
                          <InputGroup>                                                        
                            <div class="input-group-prepend">
                              <label class="input-group-text" for="inputGroupSelect01">故事類別</label>
                            </div>
                            
                            <Input type="select" name="select" className="custom-select"   
                              value={this.GS.getStory().category}
                              onChange={(e) => {
                                this.GS.getStory().category = e.target.value;
                                this.forceUpdate();
                              }}
                            >
                              <option value={'ROMANCE'}>{'愛 Love & Romance'}</option>
                              <option value={'SCIENCE_FICTION'}>{'幻 Sci-Fi'}</option>
                              <option value={'MYSTERY'}>{'懸 Thriller'}</option>    
                              <option value={'COMEDY'}>{'喜 Comedy'}</option>
                              <option value={'HORROR'}>{'動 Action'}</option>
                              <option value={'CHINESE_MARTIAL'}>{'無 Others'}</option>
                            </Input>
                          </InputGroup>
                          
                          
                      </h3>
                      <hr/>
                      <textarea class="description" contentEditable='true'
                          onInput=
                          {
                            e => {
                              //console.log(e.currentTarget.innerHTML);
                              /*var temp = e.currentTarget.innerHTML.replace(/<\/div><div>/g,"\n").replace("<div>","\n").replace("</div>","").replace(/<br>/g,'');
                              console.log(temp);
                              //this.GS.getStory().description = e.currentTarget.textContent;                            */
                              var temp = e.currentTarget.value;
                              this.GS.getStory().description = temp;
                            }
                          }
                          onPaste=
                          {
                            e =>{
                              e.preventDefault()
                              if (e.clipboardData && e.clipboardData.getData) {
                                var text = e.clipboardData.getData("text/plain");
                                document.execCommand("insertHTML", false, text);
                              }
                            }
                          }
                        >
                        {this.GS.getStory().description}
                      </textarea>

                      {(this.GS.getStory().channel!=true)?
                      <InputGroup>                                                        
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="SIXTEEN_PLUS" id="SIXTEEN_PLUS"
                          onChange={()=>{this.toggleCheckbox('SIXTEEN_PLUS')}}
                          defaultChecked={this.warningList.has('SIXTEEN_PLUS')}
                          />
                          <label class="form-check-label" for="SIXTEEN_PLUS">
                            此故事只適合18歲或以上人士觀看
                          </label>
                        </div>
                      </InputGroup>
                      :null}
                      {(this.GS.getStory().channel!=true)?
                      <InputGroup>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="SOUND" id="SOUND"
                          onChange={()=>{this.toggleCheckbox('SOUND')}}                          
                          defaultChecked={this.warningList.has('SOUND')}
                          />
                          <label class="form-check-label" for="SOUND">
                            此故事具音效
                          </label>
                        </div>
                        
                      </InputGroup>
                      :null}

                      <button className="btn btn-primary mt-3 mb-4" onClick={()=>{
                        this.connector.createStory(()=>{
                          alert("已更新!")
                        },0);                      
                      }}>更新</button>
                  </div>
              </section>
              </Row>
            </Container>
          
        </div>
    )
  }
}